<template>
  <div>
    <!-- 常见问题 -->
    <div class="problem">
      <div class="selec_box">
        <div
          @click="changeActive(item, index)"
          :class="activeSelect === index ? 'selec_item1' : 'selec_item'"
          v-for="(item, index) in selectArr"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="collapse_box">
        <el-collapse
          accordion
          class="collapse_accordion"
          v-if="problemArr[activeSelect]"
        >
          <el-collapse-item
            v-for="(item, index) in problemArr[activeSelect][pagegationActive]" :key="index" >
            <template slot="title">
              <img
                class="problem_icon"
                src="../../assets/indexImg/problem_icon.png"
                alt=""
              />
             {{item.one}}
             <!-- <i class="header-icon el-icon-info"></i> -->
            </template>
            <div class="info">
              {{item.two}}
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="pagegation_box">
        <div class="center_box" v-if="problemArr">
          <div 
            :class="
              pagegationActive === index
                ? 'pagegatiuonItem'
                : 'pagegatiuonItem1'
            "
            v-for="(item, index) in problemArr[activeSelect]"
            :key="index"
            @click="topages(index)"
          >
            {{ index + 1 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    problemArr: {
      type: Array,
    },
  },
  components: {},
  data() {
    return {
      activeSelect: 0,
      pagegationActive: 0,
      selectArr: [
        {
          name: "产品相关",
          id: 1,
        },
        {
          name: "安装相关",
          id: 2,
        },
        {
          name: "维护相关",
          id: 3,
        },
        {
          name: "其他问题",
          id: 4,
        },
      ],
    };
  },
  methods: {
    changeActive(item, index) {
      this.activeSelect = index;
    },
    topages(index) {
      this.pagegationActive = index;
    },
  },
};
</script>

<style scoped lang='scss'>
.problem {
  width: 1200px;
  height: 100%;
  color: #fff;
  // margin-top: 40px;
  margin-top: 4vh;
  margin-bottom: 6vh;
  .selec_box {
    width: 100%;
    // height: 60px;
    height:6vh;
    background: rgba(15, 255, 255, 0.2);
    display: flex;
    justify-content: space-between;
    .selec_item {
      width: 25%;
      height: 100%;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 60px;
      line-height: 6vh;
      color: rgba(255, 255, 255, 0.5);
      text-align: center;
      cursor: url("../../assets/cursor.png"), none;
    }
    .selec_item1 {
      width: 25%;
      height: 100%;
      background: rgba(15, 255, 255, 0.2);
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 60px;
      line-height: 6vh;
      color: #ffffff;
      text-align: center;
      cursor: url("../../assets/cursor.png"), none;
    }
  }
  .collapse_box {
    // min-height: 325px;
    min-height: 32.5vh;
    // margin-bottom: 40px;
    margin-bottom: 4vh;
    .collapse_accordion {
      background: transparent !important;
      border-left: 1px solid #ffffff;
      border-right: 1px solid #ffffff;
      .problem_icon {
        width: 22px;
        height: 22px;
        margin-left: 20px;
        // margin-right: 10px;
        margin-right: 1vh;
      }
      .info {
        width: 95%;
        font-size: 16px;
        line-height: 24px;
        margin: 0 auto;
        text-indent: 20px;
      }
    }
  }

  .pagegation_box {
    width: 100%;
    // height: 30px;
    height: 3vh;
    .center_box {
      width: auto;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      .pagegatiuonItem {
        width: 30px;
        // height: 30px;
        height: 30px;
        border: 1px solid #0fffff;
        border-radius: 50%;
        // line-height: 30px;
        line-height: 30px;
        text-align: center;
        margin-left: 40px;
        color: #0fffff;
      }
      .pagegatiuonItem1 {
        width: 30px;
        // height: 30px;
        height: 30px;
        border-radius: 50%;
        // line-height: 30px;
        line-height: 30px;
        text-align: center;
        margin-left: 40px;
        
      }
    }
  }
}
</style>